<template>
    <div v-if="['birthday-message', 'birthday-month-message'].includes(template.template_context)">
        <m-edit-text
            v-if="template.template_context === 'birthday-month-message'"
            label="Day of month to send (1-27)"
            hint="This message will only attempt to send on this day of the month"
            class="mb-4"
            v-model="template.param_delay_days"
            :rules="[validateDayOfMonthForBirthdayMonth]"
            :read_only="read_only"
            integer_positive
            @input="onInput"
        />
        <m-edit-text
            v-if="template.template_context === 'birthday-message'"
            hint="Positive value: Sends the message that many days AFTER the birthday. Negative value: Sends the message that many days BEFORE the birthday. Zero: Sends the message ON the birthday. "
            label="Day to send relative to birthday"
            class="mb-1"
            v-model="template.param_delay_days"
            :read_only="read_only"
            integer
            @input="onInput"
        />
        <div
            v-if="template.template_context === 'birthday-message'"
            class="when-sent-description mb-4 ml-4"
        >
            <span v-if="template.param_delay_days == 0">
                <i>This message will be sent <strong>on the day of the birthday</strong>.</i>
            </span>
            <span v-else-if="template.param_delay_days == 1">
                <i>This message will be sent <strong>1 day after the birthday</strong>.</i>
            </span>
            <span v-else-if="template.param_delay_days > 1">
                <i>This message will be sent <strong>{{ template.param_delay_days }} days after the birthday</strong>.</i>
            </span>
            <span v-else-if="template.param_delay_days == -1">
                <i>This message will be sent <strong>1 day before the birthday</strong>.</i>
            </span>
            <span v-else>
                <i>This message will be sent <strong>{{ Math.abs(template.param_delay_days) }} days before the birthday</strong>.</i>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        template: {
            type: Object,
            required: true
        },
        read_only: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        onInput() {
            this.$emit('input');
        },

        validateDayOfMonthForBirthdayMonth(value) {
            if (value === null || value === undefined || value === '') return true;

            const day = parseInt(value);
            if (isNaN(day)) return 'Please enter a valid number';
            if (day < 1 || day > 27) return 'Day of month must be between 1 and 27';

            return true;
        }
    }
}
</script>

<style lang="scss" scoped>
.when-sent-description {
    color: rgba(0,0,0,0.6);
    font-size: 14px;
}
</style>
